module.exports = __webpack_public_path__ + "img/sonido.50d9b608.svg";